module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 4@2x(1).0f9a5083.png";